import _ from 'lodash'

import { MydAPI } from '_services/default'
import {
  FETCHING_TRANSLATIONS,
  FETCHED_TRANSLATIONS,
  CHANGE_LANGUGAGE,
} from '_reducers/i18n'

export const changeLanguage = lang => ({
  type: CHANGE_LANGUGAGE,
  lang,
})

const fetchingTranslations = () => ({
  type: FETCHING_TRANSLATIONS,
})

const fetchedTranslations = translations => ({
  type: FETCHED_TRANSLATIONS,
  translations,
})

export const fetchTranslations = _.memoize(locale => {
  return dispatch => {
    dispatch(fetchingTranslations())
    return new Promise((resolve, reject) => {

      MydAPI.get(`/small/i18n/${locale}`).then(translations => {
        let retTranslations = translations.data

        dispatch(fetchedTranslations(retTranslations))
        resolve(retTranslations)

      }).catch(err => {
        dispatch(fetchedTranslations([]))
        reject(err)
      })
    })
  }
})
